import React, { useEffect, useRef } from 'react';
import { IConvertConfig } from '../../../@types/Convert';

interface Props {
    onSettingChange: (config: IConvertConfig) => void;
}

function SrtToFCPXML(props: Props) {
    const refWidth = useRef<HTMLInputElement>(null);
    const refHeight = useRef<HTMLInputElement>(null);
    const refFPS = useRef<HTMLSelectElement>(null);

    useEffect(() => { props.onSettingChange({ width: Number(refWidth.current?.value), height: Number(refHeight.current?.value), fps: Number(refFPS.current?.value ) }); }, []);

    const onSelectChange = (event: any) => {
        props.onSettingChange({ width: Number(refWidth.current?.value), height: Number(refHeight.current?.value), fps: Number(refFPS.current?.value ) }); 
    };

    return (
        <>
            <h3 className='text-xl text-center mb-1'>Convert Setting</h3>
            <div className='grid grid-cols-3 gap-4 mb-5'>
                <div>
                    <label data-tooltip-target="tooltip-video-width" htmlFor="videoWidth" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Video Width<i className="fa-solid fa-circle-info ml-1.5"></i></label>
                    <input onChange={onSelectChange} ref={refWidth} type="number" min={100} max={9999} id="videoWidth" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="1920" defaultValue={"1920"} required/>
                    <div id="tooltip-video-width" role="tooltip" className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
                        Use your media's width
                        <div className="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </div>
                <div>
                    <label data-tooltip-target="tooltip-video-height" htmlFor="videoHeight" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Video Height<i className="fa-solid fa-circle-info ml-1.5"></i></label>
                    <input onChange={onSelectChange} ref={refHeight} type="number" min={100} max={9999} id="videoHeight" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="1080" defaultValue={"1080"} required/>
                    <div id="tooltip-video-height" role="tooltip" className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
                        Use your media's height
                        <div className="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </div>
                <div>
                    <label data-tooltip-target="tooltip-video-fps" htmlFor="videoFps" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Framerate<i className="fa-solid fa-circle-info ml-1.5"></i></label>
                    <select onChange={onSelectChange} ref={refFPS} id="videoFps" className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        <option value="23.976">23.976</option>
                        <option value="24">24</option>
                        <option value="25">25</option>
                        <option value="29.97">29.97</option>
                        <option value="30" selected>30</option>
                        <option value="59.94">59.94</option>
                        <option value="60">60</option>
                    </select>
                    <div id="tooltip-video-fps" role="tooltip" className="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-gray-900 rounded-lg shadow-sm opacity-0 tooltip dark:bg-gray-700">
                        Use your media's framerate
                        <div className="tooltip-arrow" data-popper-arrow></div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default React.memo(SrtToFCPXML);